import React from 'react'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import {
  FooterFlex,
  Form,
} from 'modules/Onboarding/Partials/Corporates/Partials/AddNewCorporateDrawer/Style/style'
import InstitutePlanDetails from 'modules/Onboarding/Partials/Corporates/Partials/PlanDrawer/Partials/PlanDetails'

const InstitutePlanDrawer = ({
  form,
  instituteClear,
  institutePlanDrawer,
  setInstitutePlanDrawer,
  setNewInstituteDocumentDrawer,
  title = 'Choose Plan',
  sendButtonText = 'Next',
  setInstituteDrawer,
}) => {
  const onClear = () => {
    form.resetFields()
    setInstitutePlanDrawer(false)
    instituteClear()
  }

  const onBack = () => {
    setInstituteDrawer(true)
    setInstitutePlanDrawer(false)
  }

  const onSubmitFormData = async formData => {
    setInstitutePlanDrawer(false)
    setNewInstituteDocumentDrawer(true)
  }
  const content = () => {
    return (
      <div>
        <Form
          scrollToFirstError
          onFinish={onSubmitFormData}
          id={'planForm'}
          form={form}
          layout="vertical"
        >
          <InstitutePlanDetails />
        </Form>
      </div>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Back"
          onClick={() => {
            onBack()
          }}
        />
        <Button.Primary
          htmlType="submit"
          form="planForm"
          text={sendButtonText}
        />
      </FooterFlex>
    )
  }
  return (
    
      <Drawer
        title={title}
        placement="right"
        closable={true}
        onClose={() => {
          onClear()
        }}
        visible={institutePlanDrawer}
        content={content()}
        footer={footer()}
      />
    
  )
}

export default InstitutePlanDrawer
